const toQueryStringProp = ({ group, id }: { group: string; id: string }) => `${group}:${id}`;

export const toQueryString = (suggestions: Array<{ group: string; id: string }>) =>
  suggestions.map(toQueryStringProp).join(';');
